import { render, staticRenderFns } from "./FixAlert.vue?vue&type=template&id=82156dd4&scoped=true"
import script from "./FixAlert.vue?vue&type=script&lang=js"
export * from "./FixAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82156dd4",
  null
  
)

export default component.exports